import { css } from '@emotion/react'

import common from 'shared/styles'

import custom from 'shared/styles/custom.styles'

const styles = () => {
    return {
        actions: css`
          ${common.flexJustityAlignCenter};
          padding: 0;
        `,
        button: css`
          width: auto !important;
          margin: 50px 25px 50px 25px;
          ${custom.button};
        `,
    }
}

export default styles
